import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataGridConfigService {
  private expotName: string = 'ExportFile'; // Varsayılan ID

  /**
   * Datagrid'de export edilecek dosya adını ayarlar
   *
   * @param name - dosya adı
   * @returns void.
   */
  setGridExportName(name: string) {
    this.expotName = name;
  }

  /**
   * Datagrid'de export edilecek dosya adını verir
   *
   * @returns Dosya adı.
   */
  getGridExportName(): string {
    return this.expotName;
  }
}
